export enum DictionaryKeysEnum {
  Countries = "countries",
  CryptoAssets = "cryptoAssets",
  Currencies = "currencies",
  Operations = "operations",
  PaymentMethods = "paymentMethods",
  PaymentSystemStatuses = "paymentSystemStatuses",
  PaymentSystemSubmethods = "paymentSystemSubmethods",
  TransactionStatuses = "transactionStatuses",
  Types = "types",
  Sources = "sources",
}
